const API_URL = 'https://api.app.srmachennai.com/api/';

export default API_URL;
